// api/authApi.js - Kimlik doğrulama API istekleri
import apiClient from './apiClient';
import axios from 'axios';

const BASE_URL = '/api/users';

// Kullanıcı girişi
export const login = async (username, password) => {
  return await apiClient.post('/auth/login', { username, password });
};

// Kullanıcı çıkışı
export const logout = async () => {
  return await apiClient.post('/auth/logout');
};

// Mevcut kullanıcı bilgilerini getir
export const getMe = async () => {
  return await apiClient.get('/auth/me');
};

// 2FA durumunu getir
export const get2FAStatus = async () => {
  try {
    const response = await apiClient.get('/auth/2fa/status');
    return response;
  } catch (error) {
    console.error('2FA durum kontrolü hatası:', error);
    throw error.response?.data || error.message || { message: '2FA durumu kontrol edilirken hata oluştu.' };
  }
};

// 2FA için secret key ve QR kod oluştur
export const setup2FA = async () => {
  try {
    const response = await apiClient.post('/auth/2fa/setup');
    return response;
  } catch (error) {
    console.error('2FA kurulum hatası:', error);
    throw error.response?.data || error.message || { message: '2FA kurulumu başlatılırken hata oluştu.' };
  }
};

// 2FA doğrulama kodunu kontrol et ve etkinleştir
export const verify2FA = async (token) => {
  try {
    const response = await apiClient.post('/auth/2fa/verify', { token });
    return response;
  } catch (error) {
    console.error('2FA doğrulama hatası:', error);
    throw error.response?.data || error.message || { message: '2FA doğrulaması sırasında hata oluştu.' };
  }
};

// 2FA'yı devre dışı bırak
export const disable2FA = async (password) => {
  try {
    const response = await apiClient.post('/auth/2fa/disable', { password });
    return response;
  } catch (error) {
    console.error('2FA devre dışı bırakma hatası:', error);
    throw error.response?.data || error.message || { message: '2FA devre dışı bırakılırken hata oluştu.' };
  }
};

// Oturum açma
export const loginUser = async (username, password) => {
  try {
    const response = await axios.post(`${BASE_URL}/login`, { username, password });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Giriş işlemi başarısız.' };
  }
};

// 2FA için doğrulama kodu kontrolü
export const validate2FAForLogin = async (code, userId) => {
  try {
    console.log('2FA doğrulama için istek gönderiliyor:', { code, userId });
    // apiClient kullan ve doğru endpointi kullan
    const response = await apiClient.post('/auth/2fa/validate', { token: code, userId });
    
    console.log('2FA doğrulama yanıtı:', response);
    
    if (!response || !response.token) {
      console.error('2FA yanıt hatası: Token bulunamadı');
      throw new Error('Doğrulama başarılı ancak oturum bilgileri alınamadı');
    }
    
    return response;
  } catch (error) {
    console.error('2FA doğrulama API hatası:', error);
    throw error.response?.data || error.message || { message: 'Doğrulama kodu geçersiz.' };
  }
};

// Kullanıcı bilgilerini alma
export const getCurrentUser = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/me`);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Kullanıcı bilgileri alınamadı.' };
  }
};

// Şifre değiştirme
export const changePassword = async (currentPassword, newPassword) => {
  try {
    const response = await axios.post(`${BASE_URL}/change-password`, { currentPassword, newPassword });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Şifre değiştirilemedi.' };
  }
};

// Başarısız giriş denemelerini kontrol et
export const checkLoginAttempts = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/login-attempts`);
    return response.data;
  } catch (error) {
    // Sunucu tarafında bu endpoint yoksa, client-side bir yaklaşım kullan
    const storedData = localStorage.getItem('login_attempts');
    if (storedData) {
      const attemptData = JSON.parse(storedData);
      const now = new Date();
      const blockedUntil = new Date(attemptData.blockedUntil || 0);
      
      // Engelleme süresi geçtiyse, engellemeyi kaldır
      if (blockedUntil <= now) {
        if (attemptData.isBlocked) {
          localStorage.setItem('login_attempts', JSON.stringify({
            attempts: 0,
            isBlocked: false,
            blockedUntil: null,
            timestamp: now.toISOString()
          }));
        }
        return { attempts: attemptData.attempts, isBlocked: false };
      }
      
      return attemptData;
    }
    
    // Veri yoksa, başlangıç verisini oluştur
    localStorage.setItem('login_attempts', JSON.stringify({
      attempts: 0,
      isBlocked: false,
      blockedUntil: null,
      timestamp: new Date().toISOString()
    }));
    
    return { attempts: 0, isBlocked: false };
  }
};

// Başarısız giriş denemesi kaydet
export const recordFailedAttempt = async (username) => {
  try {
    const response = await axios.post(`${BASE_URL}/login-attempts`, { username });
    return response.data;
  } catch (error) {
    // Sunucu tarafında bu endpoint yoksa, client-side bir yaklaşım kullan
    const storedData = localStorage.getItem('login_attempts');
    let attemptData = {
      attempts: 0,
      isBlocked: false,
      blockedUntil: null,
      timestamp: new Date().toISOString()
    };
    
    if (storedData) {
      attemptData = JSON.parse(storedData);
    }
    
    // Deneme sayısını artır
    attemptData.attempts += 1;
    
    // 10 denemeyi geçtiyse, engelle (15 dakika - 900000 milisaniye)
    if (attemptData.attempts >= 10 && !attemptData.isBlocked) {
      const now = new Date();
      const blockUntil = new Date(now.getTime() + 15 * 60 * 1000);
      
      attemptData.isBlocked = true;
      attemptData.blockedUntil = blockUntil.toISOString();
    }
    
    localStorage.setItem('login_attempts', JSON.stringify(attemptData));
    return attemptData;
  }
};

// Başarılı giriş sonrası deneme sayılarını sıfırla
export const resetLoginAttempts = async () => {
  try {
    const response = await axios.delete(`${BASE_URL}/login-attempts`);
    return response.data;
  } catch (error) {
    // Sunucu tarafında bu endpoint yoksa, client-side bir yaklaşım kullan
    localStorage.setItem('login_attempts', JSON.stringify({
      attempts: 0,
      isBlocked: false,
      blockedUntil: null,
      timestamp: new Date().toISOString()
    }));
    
    return { success: true };
  }
};

export default {
  login,
  logout,
  getMe,
  get2FAStatus,
  setup2FA,
  verify2FA,
  disable2FA,
  validate2FAForLogin
};